import $ from 'jquery';
import _ from 'lodash';

//ドロップダウンメニューを作成
export function DropdownToolList() {
  // eslint-disable-next-line no-unused-vars
  var dropdown_id;
  // eslint-disable-next-line no-unused-vars
  var val_list;
  // eslint-disable-next-line no-unused-vars
  var change_event;
}

DropdownToolList.prototype.init = function(id, change_event, init_value) {
  this.dropdown_id = id;
  this.input = $(`#${id} input`);
  this.change_event = change_event;
  let _this = this;
  let val_list = [];
  if (init_value) {
    $(_this.input).val(init_value);
  }
  $(_this.input).change(function() {
    _this.setValue($(this).val(), true);
  });
  _.each($(`#${_this.dropdown_id} .dropdown-tool-list button`), function(data) {
    val_list.push($(data).attr('data-value'));
  });
  _this.val_list = val_list;
  _this.addEvent(id);
};

DropdownToolList.prototype.addEvent = function() {
  let _this = this;

  $(`#${_this.dropdown_id} .dropdown-tool-list li`).click(function() {
    _this.setValue(
      $(this)
        .children('button')
        .attr('data-value'),
      true
    );
  });

  $(
    `#${_this.dropdown_id} .select-down, #${
      _this.dropdown_id
    } .select-up-reverse`
  ).click(function() {
    let input_val = $(_this.input).val();
    let index = 0;
    let find = false;
    _.each(_this.val_list, function(val, i) {
      if (val == input_val || find) {
        find = true;
        return;
      }
      index = i;
    });
    if (_this.val_list[index] !== undefined) {
      _this.setValue(_this.val_list[index], true);
    }
    $(this)
      .closest('.tool-item--sm.selected')
      .removeClass('selected');
  });

  $(
    `#${_this.dropdown_id} .select-up, #${
      _this.dropdown_id
    } .select-down-reverse`
  ).click(function() {
    let input_val = $(_this.input).val();
    let index = 0;
    let find = false;
    _.each(_this.val_list, function(val, i) {
      if (find) {
        return;
      }
      index = i;
      if (val == input_val) {
        index++;
        find = true;
      }
    });
    if (_this.val_list[index] !== undefined) {
      _this.setValue(_this.val_list[index], true);
    }

    $(this)
      .closest('.tool-item--sm.selected')
      .removeClass('selected');
  });
};

DropdownToolList.prototype.setValue = function(val, onChange) {
  let _this = this;
  _this.change_event(val, onChange);
};

// eslint-disable-next-line no-unused-vars
DropdownToolList.prototype.getValue = function(val, onChange) {
  let _this = this;
  return $(_this.input).val();
};



// WEBPACK FOOTER //
// ./src/canvas/common/DropDownToolList.js